import { Base } from "ui/Scripts/source/framework/base";
import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IRecordEditItemEmployment extends IEditItem {
    startDate: number;
    endDate: number;
    companyName: string;
    jobTitle: string;
    comment: string;
    modifyUser: IModifyUser;

    getTitle(): string;
    getUiTitle(): string;
}

export class RecordEditItemEmployment extends EditItem implements IRecordEditItemEmployment {
    startDate: number;
    endDate: number;
    companyName: string;
    jobTitle: string;
    comment: string;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: IRecordEditItemEmployment);
    constructor(obj?: any) {
        super(obj);
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.companyName = obj && obj.companyName || "";
        this.jobTitle = obj && obj.jobTitle || "";
        this.comment = obj && obj.comment || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }

    getUiTitle(): string {
        return ((this.companyName ? this.companyName + " " : "") + (this.jobTitle ? this.jobTitle : "")).trim();
    }

    getTitle(): string {
        return this.getUiTitle();
    }
        
    static sortRecordEditItemEmployments(items: IRecordEditItemEmployment[], column: string, asc: boolean): IRecordEditItemEmployment[] {
        if (!items && items.length < 2) return items;
        if (column === "startDate") {
            return items.sort((a: IRecordEditItemEmployment, b: IRecordEditItemEmployment) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate)); });
        } else if (column === "endDate") {
            return items.sort((a: IRecordEditItemEmployment, b: IRecordEditItemEmployment) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.endDate, b.endDate)); });
        } else if (column === "companyName") {
            return items.sort((a: IRecordEditItemEmployment, b: IRecordEditItemEmployment) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.companyName, b.companyName)); });
        } else if (column === "comment") {
            return items.sort((a: IRecordEditItemEmployment, b: IRecordEditItemEmployment) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            return items.sort((a: IRecordEditItemEmployment, b: IRecordEditItemEmployment) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.jobTitle, b.jobTitle)); });
        }
    }
}

export class RecordEditItemEmploymentSave extends EditItem {
    startDate: number;
    endDate: number;
    companyName: string;
    jobTitle: string;
    comment: string;

    constructor();
    constructor(obj: IRecordEditItemEmployment);
    constructor(obj?: any) {
        super(obj);
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.companyName = obj && obj.companyName || "";
        this.jobTitle = obj && obj.jobTitle || "";
        this.comment = obj && obj.comment || "";
    }
}
